import { Record } from "immutable";

import { DropdownsState } from "../../features/dropdowns/state";

export enum AssignmentsFilter {
  todo = "todo",
  done = "done",
  missed = "missed"
}

export type ParentUiStateType = {
  dropdowns: DropdownsState;
  assignmentsFilter: AssignmentsFilter;
};

const defaultParentUIState: ParentUiStateType = {
  dropdowns: new DropdownsState(),
  assignmentsFilter: AssignmentsFilter.todo
};

export default class ParentUiState extends Record(defaultParentUIState) {}
